var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-content account acc_verification" }, [
    !_vm.accountSummaryFlow
      ? _c("h1", [_vm._v(_vm._s(_vm.$t("Account.Verification")))])
      : _vm._e(),
    _vm._v(" "),
    false
      ? _c("div", { staticClass: "verified" }, [
          _vm.isCustomerVerified
            ? _c("span", [
                _vm._v(_vm._s(_vm.$t("Account.Verification.Customer.Verified")))
              ])
            : _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("Account.Verification.Customer.NotVerified"))
                )
              ])
        ])
      : _vm._e(),
    _vm._v(" "),
    !(
      _vm.personalDataAdditionalUploadNeeded &&
      _vm.mobileNumberAdditionalUploadNeeded
    )
      ? _c("div", { staticClass: "phone verify ctsform" }, [
          _c("div", { staticClass: "phone-verify" }, [
            _c("h2", [
              _vm._v(
                _vm._s(
                  _vm.$t("Account.Verification.Customer.PersonalData.Title")
                )
              )
            ]),
            _vm._v(" "),
            _vm.aristotleVerificationStatus || _vm.manualVerificationStatus
              ? _c("div", { staticClass: "flow-wrapper" }, [
                  _vm.isWIDShouldVerify
                    ? _c("div", [
                        _vm.aristotleVerificationStatus === "sent"
                          ? _c("div", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "Account.Verification.Aristotle.InProgress"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-actions" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "success",
                                        "x-large": ""
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.refreshCustomerContext()
                                        }
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Account.Verification.Aristotle.Refresh"
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          : _c("div", [
                              _c("h2", { staticClass: "additional-info" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Account.Verification.Customer.PersonalData.ActionRequired"
                                    )
                                  )
                                )
                              ]),
                              _c("br"),
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "Account.Verification.Customer.PersonalData.ShouldVerifyInCasinoAfterKYCFailed"
                                    )
                                  ) +
                                  "\n          "
                              )
                            ])
                      ])
                    : _vm.isAristotleVerified ||
                      (_vm.aristotleVerificationStatus === "failed" &&
                        _vm.isManuallyVerified)
                    ? _c("div", { staticClass: "verified" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "Account.VerificationByPin.Aristotle.Verified"
                              )
                            ) +
                            "\n        "
                        )
                      ])
                    : _vm.aristotleVerificationStatus === "sent"
                    ? _c("div", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "Account.Verification.Aristotle.InProgress"
                              )
                            ) +
                            "\n          "
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-actions" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "success", "x-large": "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.refreshCustomerContext()
                                  }
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Account.Verification.Aristotle.Refresh"
                                      )
                                    )
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    : _vm.aristotleVerificationStatus === "failed" &&
                      _vm.manualVerificationStatus === "sent"
                    ? _c("div", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("Account.Verification.Manual.InProgress")
                            ) +
                            "\n          "
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-actions" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "success", "x-large": "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.refreshCustomerContext()
                                  }
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Account.Verification.Aristotle.Refresh"
                                      )
                                    )
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    : _vm.personalDataAdditionalUploadNeeded
                    ? _c("div", { staticClass: "not-verified" }, [
                        _c("h2", { staticClass: "additional-info" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Account.VerificationByPin.Aristotle.AdditionalVerification.Title"
                              )
                            )
                          )
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "Account.VerificationByPin.Aristotle.AdditionalVerification.Info"
                              )
                            )
                          }
                        }),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-actions" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "success",
                                  "x-large": "",
                                  id: "btn_verify"
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.verifyPersonalData()
                                  }
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Account.Verification.Aristotle.Verify"
                                      )
                                    )
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    : _c("div", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "Account.Verification.ContactCustomerSupport"
                              )
                            ) +
                            "\n        "
                        )
                      ])
                ])
              : _c("div", { staticClass: "flow-wrapper" }, [
                  _vm.isWIDShouldVerify
                    ? _c("div", [
                        _c("h2", { staticClass: "additional-info" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Account.Verification.Customer.PersonalData.ActionRequired"
                              )
                            )
                          )
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "Account.Verification.Customer.PersonalData.ShouldVerify"
                              )
                            ) +
                            "\n        "
                        )
                      ])
                    : _c("div", { staticClass: "verified" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "Account.Verification.Customer.PersonalData.AlreadyVerified"
                              )
                            ) +
                            "\n        "
                        )
                      ])
                ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    (_vm.m2p || _vm.p2p) &&
    !(
      _vm.personalDataAdditionalUploadNeeded &&
      _vm.mobileNumberAdditionalUploadNeeded
    )
      ? _c("div", { staticClass: "phone verify ctsform" }, [
          _c("div", { staticClass: "phone-verify" }, [
            _c("h2", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "Account.Verification.Customer.MobileNumberOwnership.Title"
                  )
                )
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flow-wrapper" }, [
              _vm.p2pVerified ||
              (_vm.p2p === "failed" && _vm.m2pVerified) ||
              _vm.mkaVerified
                ? _c("div", { staticClass: "verified" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "Account.Verification.Customer.MobileNumberOwnership.Verified"
                          )
                        ) +
                        "\n        "
                    )
                  ])
                : _vm.p2p === "sent"
                ? _c("div", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "Account.Verification.Customer.MobileNumberOwnership.InProgress"
                          )
                        ) +
                        "\n          "
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-actions" },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "success", "x-large": "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.refreshCustomerContext()
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Account.Verification.Aristotle.Refresh"
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ])
                : _vm.p2p === "failed" && _vm.m2p === "sent"
                ? _c("div", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "Account.Verification.Customer.MobileNumberOwnership.ManualMatch.InProgress"
                          )
                        ) +
                        "\n          "
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-actions" },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "success", "x-large": "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.refreshCustomerContext()
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Account.Verification.Aristotle.Refresh"
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ])
                : _vm.mobileNumberAdditionalUploadNeeded
                ? _c("div", { staticClass: "not-verified" }, [
                    _c("h2", { staticClass: "additional-info" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "Account.VerificationByPin.Aristotle.AdditionalVerification.Title"
                          )
                        )
                      )
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t(
                            "Account.Verification.Customer.MobileNumberOwnership.AdditionalVerification.Info"
                          )
                        )
                      }
                    }),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-actions" },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              color: "success",
                              "x-large": "",
                              id: "btn_verify"
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.verifyPersonalData()
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Account.Verification.Aristotle.Verify"
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ])
                : _c("div", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "Account.Verification.Customer.MobileNumberOwnership.ContactCustomerSupport"
                          )
                        ) +
                        "\n        "
                    )
                  ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.personalDataAdditionalUploadNeeded &&
    _vm.mobileNumberAdditionalUploadNeeded
      ? _c("div", { staticClass: "phone verify ctsform" }, [
          _c("div", { staticClass: "phone-verify personal-data" }, [
            _c("h2", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "Account.Verification.Customer.PersonalDataAndMobileNumberOwnership.Title"
                  )
                )
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "not-verified" }, [
              _c("h2", { staticClass: "additional-info" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "Account.VerificationByPin.Aristotle.AdditionalVerification.Title"
                    )
                  )
                )
              ]),
              _c("br"),
              _vm._v(" "),
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t(
                      "Account.Verification.Customer.PersonalDataAndMobileNumberOwnership.AdditionalVerification.Info"
                    )
                  )
                }
              }),
              _c("br"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-actions" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "success",
                        "x-large": "",
                        id: "btn_verify"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.verifyPersonalData()
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("Account.Verification.Aristotle.Verify")
                          )
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "mail verify ctsform" }, [
      _c(
        "div",
        { staticClass: "mail-verify" },
        [
          _c("h2", [
            _vm._v(_vm._s(_vm.$t("Account.JoinUs.VerificationByPin.Email")))
          ]),
          _vm._v(" "),
          _vm.isEmailVerified
            ? _c("div", { staticClass: "verified" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("Account.VerificationByPin.Email.Verified")) +
                    "\n      "
                )
              ])
            : _c("VerificationByPin", {
                staticClass: "not-verified",
                attrs: { verify: "email" }
              })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "phone verify ctsform" }, [
      _c(
        "div",
        { staticClass: "phone-verify" },
        [
          _c("h2", [
            _vm._v(_vm._s(_vm.$t("Account.JoinUs.VerificationByPin.Phone")))
          ]),
          _vm._v(" "),
          _vm.isPhoneVerified
            ? _c("div", { staticClass: "verified" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("Account.VerificationByPin.Phone.Verified")) +
                    "\n      "
                )
              ])
            : _c("VerificationByPin", {
                staticClass: "not-verified",
                attrs: { verify: "phone" }
              })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dcf2f448", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcf2f448","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/IntegratedWallet/Verification.vue
// module id = null
// module chunks = 